import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = {
  class: "xrk-card",
  style: {"width":"420px","height":"600px"}
}
const _hoisted_4 = { style: {"box-sizing":"border-box","padding":"0 20px"} }

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModuleAge from '../bi-pc-module/pc-module-process/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-9',
  setup(__props) {

const TYPE_MAPPING = [1].map(i => {
  return {
    value: 'pc-module-process-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleAge.filter(comp => comp.__name === name)[0];
};

const { curItem, titleCmpt } = useDetailCmpt({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(titleCmpt))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(titleCmpt)), _mergeProps({
                  key: 0,
                  style: {"width":"1200px","transform":"scale(0.33)","transform-origin":"0 center"},
                  ref_for: true
                }, {
              innerText: '项目执行流程',
              enInnerText: 'Project Implementation Process',
              index: 9
            }), null, 16))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)), { style: {"width":"100%","height":"100%"} }))
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})